export default __webpack_public_path__ + "static/media/teaser-etalinepro.3497d80f.png";